export default __webpack_public_path__ + "graphics/pedestrian-crossing.4ecb7a32.jpg";